import React from 'react';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import * as ResourceApi from "api/resources";
import { createButtonSectionFactory, createButtonSectionFactoryWithAdditionalArgs } from "hoc/CreateButtonSection";
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";

import { toParentField } from "utils/DBUtils";
import { isNewLayout } from 'utils/break-utils';

const showEmailFields = (resource) => {

  // resource should always exist. Failing (and now showing fields) should make the issue obvious
  if (!resource) {
    return false
  }

  return (
    (resource.communicationChannelAvailable === 'email') ||
    (resource.communicationChannelAvailable === 'either') ||
    ((resource.communicationChannelAvailable === 'sms') && (resource.smsFallbackToEmail === true))
  )
}

export default {
  name: "receiptCampaign",
  subSection: true,
  resource: true,
  hideIfResourceIsNoU: true,

  fields: [
    {
      type: 'hardcodedText',
      showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
      props: {
        heading: 'Shared Elements',
        text: "These items are used on all screens"
      }
    },
    {
      type: 'image',
      name: 'headerImageId',
      required: false,
      idFor: 'headerImage',
      props: {
        labelKey: 'editbreak.steps.receipt_verification.header_image',
        imageType: 'receiptHeader'
      }
    },
    // {
    //   type: 'hardcodedText',
    //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
    //   props: {
    //     heading: 'Legal',
    //   }
    // },
    {
      type: 'contenteditable',
      name: 'stepTerms',
      props: {
        labelKey: 'editbreak.steps.receipt_verification.step_terms'
      }
    },
    {
      name: 'communicationChannelAvailable',
      type: 'radio',
      required: true,
      props: {
        labelKey: 'How will users get notifications from us?',
        options: [
          {
            value: 'email',
            textKey: 'By Email'
          },
          {
            value: 'sms',
            textKey: 'SMS'
          },
          {
            value: 'either',
            textKey: 'Either Email or SMS'
          },

        ],
        helperText: "Note: there are copy fields within each reward based on email vs SMS"
      }
    },
    {
      name: 'smsFallbackToEmail',
      type: 'yesnoradio',
      required: false,
      showField: (proxy) => (
        (proxy.currentResource.communicationChannelAvailable === 'sms') ||
        (proxy.currentResource.communicationChannelAvailable === 'either')
      ),
      props: {
        labelKey: 'Automatically fallback to email if SMS fails?',
        helperText: "Email fields will be shown"
      }
    },
    {
      subSection: true,
      key: "receiptLandingScreen",
      sectionWrapper: IndexedSubSectionWrapper,

      props: {
        innerHeader: true,
        getInnerHeader: () => "Landing Screen / How It Works"
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'headline',
          required: false,
          // Headline is only allowed if there is more than one step
          // showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
          showField: true,
          linkedField: (formProxy) => ["title"],
          props: {
            labelKey: 'editbreak.steps.receipt_verification.headline'
          }
        },
        {
          type: 'contenteditable',
          name: 'introCopy',
          required: false,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.intro_copy',
            placeholderKey: 'editbreak.steps.receipt_verification.intro_copy.placeholder',
          }
        },
        {
          type: 'text',
          name: 'reminderBtnText',
          required: false,
          showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.steps.receipt_verification.reminder_btn_text'
          }
        },
        // {
        //   type: 'hardcodedText',
        //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
        //   props: {
        //     heading: 'User Path Selection',
        //   }
        // },

        // {
        //   type: 'text',
        //   name: 'startReminderButtonCopy',
        //   required: false,
        //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
        //   props: {
        //     labelKey: 'Button Copy - Start Reminder Flow, e.g. "Not Yet"'
        //   }
        // },

        // {
        //   type: 'text',
        //   name: 'startUploadButtonCopy',
        //   required: false,
        //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
        //   props: {
        //     labelKey: 'Button Copy - Start Upload Flow, e.g. "Have a Receipt"'
        //   }
        // },

        {
          type: 'hardcodedText',
          showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
          props: {
            heading: 'Instructions',
          }
        },

        {
          name: 'instructions',
          resource: true,
          subSection: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          deletable: true,
          canDelete: (formProxy) => {
            var receiptCampaign = formProxy.parentCurrentResource;
            return receiptCampaign.instructions && receiptCampaign.instructions.length > 1;
          },
          sortable: true,
          sortableName: "instructionsOrder",
          toggleSortLabelKey: 'editbreak.steps.receipt_verification.instruction.reorder_toggle',
          resourceType: ResourceApi.Types.ReceiptCampaignStepInstruction,

          props: {
            headerKey: 'editbreak.steps.receipt.instruction.header',
            getCustomSectionHeader: (instruction, sectionIndex) => {
              return "Instruction " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
            }
          },

          footerContent: createButtonSectionFactoryWithAdditionalArgs({
            instructionListName: "instructions"
          }, ResourceApi.Types.ReceiptCampaignStepInstruction),

          fields: [
            {
              name: 'headline',
              type: 'contenteditable',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.headline'
              }
            },
            {
              type: 'color',
              name: 'headlineTextClr',
              showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.headline_text_color'
              }
            },
            {
              type: 'contenteditable',
              name: 'desc',
              required: false,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.description'
              }
            },
            {
              conditionalSection: true,
              name: "addDetails",
              required: false,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.add_details'
              },

              fields: [
                {
                  type: 'contenteditable',
                  name: 'detailHeadline',
                  required: true,
                  showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.detail_headline'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'detailDesc',
                  required: false,
                  showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.detail_description'
                  }
                },
                {
                  type: 'image',
                  name: 'detailImageId',
                  idFor: 'detailImage',
                  required: false,
                  showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.detail_image',
                    imageType: 'receiptDetailInstruction'
                  }
                },
                {
                  type: 'color',
                  name: 'detailBackgroundClr',
                  required: false,
                  showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.detail_bg_color'
                  }
                },
                // SAME FIELD NAMES, DIFFERENT LABELS
                {
                  type: 'contenteditable',
                  name: 'detailHeadline',
                  required: false,
                  showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'Detail CTA Copy, e.g. See More'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'detailDesc',
                  required: false,
                  showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'Detail copy (modal copy)'
                  }
                },

              ]
            },// end add details conditional
            {
              type: 'radio',
              name: "iconType",
              required: false,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon_type',
                options: [
                  {
                    value: 'Icon',
                    textKey: 'editbreak.steps.receipt_verification.instruction.icon_type.icon'
                  },
                  {
                    value: 'Image',
                    textKey: 'editbreak.steps.receipt_verification.instruction.icon_type.image'
                  },
                  {
                    value: 'SVG',
                    textKey: 'Pasted SVG'
                  }
                ]
              }
            },
            // {
            //   type: 'imageurl',
            //   name: 'imageUrl',
            //   required: false,
            //   // showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
            //   props: {
            //     labelKey: 'Icon Image URL'
            //   }
            // },
            {
              type: 'textarea',
              name: 'svg',
              required: true,
              showField: (proxy) => (proxy.currentResource.iconType === 'SVG'),
              props: {
                labelKey: 'Paste SVG Code'
              }
            },
            {
              type: 'text',
              name: 'iconId',
              required: false,
              showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon.id'
              }
            },
            {
              type: 'color',
              name: 'iconFontClr',
              required: false,
              linkedField: (formProxy) => ["themeColor4"],
              showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon.color'
              }
            },
            {
              type: 'number',
              name: 'iconSize',
              required: false,
              showField: (proxy) => ((proxy.currentResource.iconType === 'Icon') && !isNewLayout(proxy.currentBaseResource)),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon.size'
              }
            },
            {
              type: 'color',
              name: 'iconBackgroundClr',
              required: false,
              linkedField: (formProxy) => ["themeColor3"],
              showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon.bg_color'
              }
            },
            {
              type: 'color',
              name: 'iconBackgroundClrHover',
              required: false,
              linkedField: (formProxy) => ["themeColor3"],
              showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
              props: {
                labelKey: 'Icon Background Color (Hover)'
              }
            },
            {
              type: 'color',
              name: 'iconBorderClr',
              required: false,
              linkedField: (formProxy) => ["themeColor4"],
              showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.icon.border_color'
              }
            },
            {
              type: 'image',
              name: 'iconId',
              idFor: 'icon',
              required: true,
              showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.image',
                imageType: 'receiptDetailInstruction'
              }
            },
            {
              type: 'color',
              name: 'iconBackgroundClr',
              required: true,
              showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.image.bg_color'
              }
            },
            {
              type: 'color',
              name: 'iconBorderClr',
              required: true,
              showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.instruction.image.border_color'
              }
            },

          ]
        },

        {
          type: 'text',
          name: 'userPathHeadline',
          required: false,
          showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'User Path Selection Header, e.g. Have a receipt already?'
          }
        },

        {
          type: 'yesnoradio',
          name: 'enableReminder',
          required: true,
          props: {
            labelKey: 'Allow users to request an email reminder',
            helperText: ''
          }
        }
      ]
    },
    {
      subSection: true,
      key: "receiptSubmissionRewards3",
      sectionWrapper: IndexedSubSectionWrapper,
      props: {
        // 'headerKey': 'editbreak.steps.lead_gen.thanks.header'
        innerHeader: true,
        getInnerHeader: () => "Rewards & Reward-Specific Copy"
      },
      fields: [

        {
          name: 'rewards',

          resource: true,
          subSection: true,
          collection: true,

          sectionWrapper: IndexedSubSectionWrapper,
          sortable: true,
          sortableName: "rewardsOrder",
          toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
          deletable: true,
          canDelete: (formProxy) => {
            return true
          },
          resourceType: ResourceApi.Types.ReceiptCampaignReward,

          props: {
            headerKey: 'editbreak.steps.receipt.requirements.header',
            getCustomSectionHeader: (reward, sectionIndex) => {
              return ((reward.title ? reward.title : "Reward " + (sectionIndex + 1)) + ((reward.hidden == true) ? " (hidden)" : ""));
            }
          },

          footerContent: createButtonSectionFactory(ResourceApi.Types.ReceiptCampaignReward),

          fields: [
            {
              type: 'currentId',
              name: 'id',
              label: 'Reward ID'
            },
            {
              type: 'contenteditable',
              name: 'title',
              required: false,
              props: {
                labelKey: 'Title'
              }
            },
            {
              type: 'image',
              name: 'rewardImageId',
              required: false,
              idFor: 'rewardImage',
              props: {
                labelKey: 'Reward Image',
                imageType: 'receiptHeader'
              }
            },
            {
              type: 'radio',
              name: 'rewardType',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.reward_section.type',
                options: [
                  // {
                  //   value: 'POINTS',
                  //   textKey: 'editbreak.steps.receipt_verification.reward_section.type.points'
                  // },
                  // {
                  //   value: 'VENDOR_DIGITAL',
                  //   textKey: 'editbreak.steps.receipt_verification.reward_section.type.vendor_digital'
                  // },
                  // {
                  //   value: 'VENDOR_PHYSICAL',
                  //   textKey: 'editbreak.steps.receipt_verification.reward_section.type.vendor_physical'
                  // },
                  {
                    value: 'CHARITY',
                    textKey: 'Charity'
                  },
                  {
                    value: 'INSTANT_WIN',
                    textKey: 'Instant Win'
                  },
                  {
                    value: 'INTERNAL_SWEEPSTAKES',
                    textKey: 'editbreak.steps.receipt_verification.reward_section.type.internal_sweepstakes'
                  },
                  {
                    value: 'POINTS',
                    textKey: 'editbreak.steps.receipt_verification.reward_section.type.points'
                  },
                  {
                    value: 'VENDOR',
                    textKey: 'Vendor'
                  },
                  {
                    value: 'BREAKTIME_CODES',
                    textKey: 'Breaktime Codes'
                  },

                ]
              }
            },
            {
              type: 'text',
              name: 'charityName',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'CHARITY'),
              props: {
                labelKey: 'Charity Name (appears in email)'
              }
            },
            {
              type: 'text',
              name: 'raffleRewardId',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'INTERNAL_SWEEPSTAKES'),
              props: {
                labelKey: 'editbreak.steps.receipt_verification.reward_section.internal_sweepstakes_id'
              }
            },
            {
              type: 'hardcodedText',
              showField: (proxy) => (proxy.currentResource.rewardType === 'INSTANT_WIN'),
              props: {
                // heading: '',
                text: "For Instant Win rewards be sure to 1) define an Instant Win in Beaker2 and 2) add the Instant Win Id to the 'Break Prizing / T & C' section of this break"
              }
            },
            {
              type: 'number',
              name: 'pointReward',
              required: true,
              showField: (proxy) => (proxy.currentResource.rewardType === 'POINTS'),
              props: {
                labelKey: 'Points to award'
              }
            },
            {
              name: 'vendor',
              type: 'dropdown',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
              props: {
                labelKey: 'Vendor',
                options: [
                  {
                    value: 'REWARDS_GENIUS_2',
                    textKey: 'Rewards Genius (aka Tango Card)'
                  },
                  {
                    value: 'REWARDS_GENIUS',
                    textKey: 'Rewards Genius (aka Tango Card) Growing Great $5 Card'
                  },
                  {
                    value: 'SKUX',
                    textKey: 'Skux'
                  },
                ]
              }
            },
            // TODO: need a way to map multiple vendor configs to a single set of name/value pairs
            // setting1, setting2, setting3 with venfor specific labels in beaker?
            // {
            //   name: 'accountIdentifier',
            //   type: 'text',
            //   required: true,
            //   showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
            //   props: {
            //     labelKey: 'Account Identifier',
            //   }
            // },
            // {
            //   name: 'customerIdentifier',
            //   type: 'text',
            //   required: true,
            //   showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
            //   props: {
            //     labelKey: 'Customer Identifier',
            //   }
            // },
            // {
            //   name: 'campaign',
            //   type: 'text',
            //   required: false,
            //   showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
            //   props: {
            //     labelKey: 'Campaign',
            //   }
            // },
            // {
            //   name: 'etid', // it's lower case in their docs
            //   type: 'text',
            //   required: false,
            //   showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
            //   props: {
            //     labelKey: 'Email Template Identifier',
            //   }
            // },

            // {
            //   name: 'amount', 
            //   type: 'currency',
            //   required: false,
            //   showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR'),
            //   props: {
            //     labelKey: 'Gift Card Amount ',
            //   }
            // },
            {
              name: 'utid',
              type: 'text',
              required: true,
              showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR' && proxy.currentResource.vendor === 'REWARDS_GENIUS_2'),
              props: {
                labelKey: 'Unique Tango Card Identifier (utid)',
              }
            },
            {
              name: 'etid',
              type: 'text',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR' && proxy.currentResource.vendor === 'REWARDS_GENIUS_2'),
              props: {
                labelKey: 'Tango Card Email Template (etid)',
              }
            },

            {
              name: 'amount',
              type: 'text',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR' && proxy.currentResource.vendor === 'REWARDS_GENIUS_2'),
              props: {
                labelKey: 'Tango Card prize amount. ',
                // min: 0.01,
                // max: 500
              }
            },

            {
              name: 'offerUUID',
              type: 'text',
              required: false,
              showField: (proxy) => (proxy.currentResource.rewardType === 'VENDOR' && proxy.currentResource.vendor === 'SKUX'),
              props: {
                labelKey: 'Offer UUID',
              }
            },

            {
              name: 'codeListIds',
              type: 'idListEditor',
              required: true,
              showField: (proxy) => (proxy.currentResource.rewardType === 'BREAKTIME_CODES'),
              props: {
                labelKey: 'Code List ID'
              }
            },

            {
              type: 'yesnoradio',
              name: 'requireName',
              required: true,
              props: {
                labelKey: 'Require First and Last name'
              }
            },

            {
              type: 'yesnoradio',
              name: 'requireAddress',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.reward_section.require_address'
              }
            },
            {
              name: 'hasAddressValidation',
              type: 'yesnoradio',
              required: true,
              props: {
                labelKey: 'Require Physical Address Validation?',
              }
            },

            {
              type: 'yesnoradio',
              name: 'requirePhoneNumber',
              required: true,
              props: {
                labelKey: 'Require Phone Number'
              }
            },
            {
              type: 'yesnoradio',
              name: 'hidden',
              required: true,
              props: {
                labelKey: 'Hidden from Consumers'
              }
            },

            {
              name: "confirmations",
              subSection: true,
              resource: true,
              collection: true,
              sectionWrapper: IndexedSubSectionWrapper,
              deletable: true,
              canDelete: (formProxy) => {
                // logic like this would force at least one item
                //   var parentReview = formProxy.parentCurrentResource;
                //   return parentReview.products && parentReview.products.length > 1;
                return true
              },
              sortable: true,
              sortableName: "confirmationsOrder",
              resourceType: ResourceApi.Types.MediaUploadConfirmation,
              toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
              props: {
                // headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                getCustomSectionHeader: (item, sectionIndex) => {
                  return `Confirmation ${(sectionIndex + 1)}`
                  // return item.label ? item.label : `Link - ${ (sectionIndex + 1) }`
                  // return product.dropdownTitle
                  // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                }
              },


              // footerContent: createButtonSectionFactory(ResourceApi.Types.MediaUploadConfirmation),
              footerContent: createButtonSectionFactoryWithAdditionalArgs({
                instructionListName: "confirmations"
              }, ResourceApi.Types.MediaUploadConfirmation),


              fields: [
                {
                  type: "contenteditable",
                  name: "text",
                  required: false,
                  props: {
                    labelKey: "Text",
                  },
                },
                {
                  type: "yesnoradio",
                  name: "required",
                  required: false,
                  props: {
                    labelKey: "Must be checked to continue",
                  },
                },



              ],
            },

            // {
            //   subSection: true,
            //   key: 'receiptSubmissionRewardsCopy',
            //   index: 85,
            //   sectionWrapper: IndexedSubSectionWrapper,
            //   props: {
            //     innerHeader: true,
            //     getInnerHeader: () => "Thank You Screen"
            //   },
            //   fields: [
            {
              type: 'hardcodedText',
              showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
              props: {
                heading: 'Thank You Screen',
              }
            },

            {
              type: 'contenteditable',
              name: 'thankyouHeader',
              required: false,
              props: {
                labelKey: 'Thank-You - Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'thankyouBody',
              required: false,
              props: {
                labelKey: 'Thank-You - Body'
              }
            },
            {
              name: "dropdownButtons",
              subSection: true,
              resource: true,
              collection: true,
              sectionWrapper: IndexedSubSectionWrapper,
              deletable: true,
              canDelete: (formProxy) => {
                // logic like this would force at least one item
                //   var parentReview = formProxy.parentCurrentResource;
                //   return parentReview.products && parentReview.products.length > 1;
                return true
              },
              sortable: true,
              sortableName: "linksOrder",
              resourceType: ResourceApi.Types.DropdownButton,
              toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
              props: {
                headerKey: 'Button Links',
                getCustomSectionHeader: (item, sectionIndex) => {
                  // console.log("custom header", item)
                  if (!item.links) {
                    item.links = []
                  }

                  let links = item.links.filter((item) => {
                    return item.deleted === false
                  })
                  if (links.length > 1) {
                    return item.buttonCopy ? item.buttonCopy : `dropdownbutton - ${(sectionIndex + 1)}`
                  } else if (links.length === 1) {
                    return links[0].label
                  } else {
                    return `dropdownbutton - ${(sectionIndex + 1)}`
                  }
                }
              },


              footerContent: createButtonSectionFactoryWithAdditionalArgs({
              }, ResourceApi.Types.DropdownButton),

              fields: [
                {
                  type: 'hardcodedText',
                  key: "links-helper",
                  props: {
                    text: 'If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.',
                  }
                },
                {
                  type: "contenteditable",
                  name: "label",
                  required: false,
                  props: {
                    labelKey: "Button Copy",
                  },
                  showField: (proxy) => {

                    let links = proxy.currentResource.links.filter((item) => {
                      return item.deleted === false
                    })

                    return (links.length > 1)
                  },
                },
                {
                  name: "links",
                  subSection: true,
                  resource: true,
                  collection: true,
                  sectionWrapper: IndexedSubSectionWrapper,
                  deletable: true,
                  canDelete: (formProxy) => {
                    // logic like this would force at least one item
                    //   var parentReview = formProxy.parentCurrentResource;
                    //   return parentReview.products && parentReview.products.length > 1;
                    return true
                  },
                  sortable: true,
                  sortableName: "linksOrder",
                  resourceType: ResourceApi.Types.DropdownButtonLink,
                  toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
                  props: {
                    //headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                    getCustomSectionHeader: (item, sectionIndex) => {
                      return item.label ? item.label : `Link - ${(sectionIndex + 1)}`
                      // return product.dropdownTitle
                      // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                    }
                  },


                  footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButtonLink),

                  fields: [
                    {
                      type: "contenteditable",
                      name: "label",
                      required: false,
                      props: {
                        labelKey: "Label",
                      },
                    },
                    {
                      type: "text",
                      name: "url",
                      required: false,
                      props: {
                        labelKey: "Url",
                      },
                    },

                  ],
                },
              ],
            },
            //   ]
            // },

            // {
            //   subSection: true,
            //   key: 'receiptSubmissionRewardsStatusCopy',
            //   index: 85,
            //   sectionWrapper: IndexedSubSectionWrapper,
            //   props: {
            //     innerHeader: true,
            //     getInnerHeader: () => "Receipt Status Screen"
            //   },
            //   fields: [
            {
              type: 'hardcodedText',
              showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
              props: {
                heading: 'Receipt Status Screen',
              }
            },
            {
              type: 'contenteditable',
              name: 'approvedHeader',
              required: false,
              props: {
                labelKey: 'Approved - Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'approvedBody',
              required: false,
              props: {
                labelKey: 'Approved - Body'
              }
            },
            {
              type: 'contenteditable',
              name: 'rejectedHeader',
              required: false,
              props: {
                labelKey: 'Rejected - Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'rejectedBody',
              required: false,
              props: {
                labelKey: 'Rejected - Body'
              }
            },

            {
              type: 'text',
              name: 'statusScreenButtonCopy',
              required: false,
              props: {
                labelKey: 'Button Copy'
              }
            },
            {
              type: 'text',
              name: 'statusScreenButtonUrl',
              required: false,
              props: {
                labelKey: 'Button URL'
              }
            },

            //   ]
            // },

            {
              subSection: true,
              key: "rewardEmails",
              sectionWrapper: IndexedSubSectionWrapper,
              showSection: (proxy) => (showEmailFields(proxy.parentCurrentResource)),
              props: {
                innerHeader: true,
                getInnerHeader: () => <Fragment>Reward-Specific Email</Fragment>
              },
              fields: [
                {
                  type: 'hardcodedText',
                  showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    heading: 'Submission Received Email',
                    text: "Sent immediately to a consumer when they submit a receipt. Will include a link to check the status of their submission."
                  }
                },
                {
                  type: 'text',
                  name: 'submittedEmailSubject',
                  required: false,
                  props: {
                    labelKey: 'Subject'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'submittedEmailTitle',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.title'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'submittedEmailBody',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.body'
                  }
                },
                {
                  type: 'text',
                  name: 'submittedEmailButtonCopy',
                  required: false,
                  props: {
                    labelKey: 'Button Copy'
                  }
                },
                {
                  type: 'text',
                  name: 'submittedEmailButtonUrl',
                  required: false,
                  props: {
                    labelKey: 'Button URL'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'submittedEmailFooter',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.footer'
                  }
                },
                {
                  type: 'hardcodedText',
                  showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    heading: 'Submission Approved Email',
                  }
                },
                {
                  type: 'text',
                  name: 'approvedEmailSubject',
                  required: false,
                  props: {
                    labelKey: 'Subject'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'approvedEmailTitle',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.approved_email_data.title'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'approvedEmailBody',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.approved_email_data.body'
                  }
                },
                {
                  type: 'text',
                  name: 'approvedEmailButtonCopy',
                  required: false,
                  props: {
                    labelKey: 'Button Copy'
                  }
                },
                {
                  type: 'text',
                  name: 'approvedEmailButtonUrl',
                  required: false,
                  //   showField: (proxy) => (proxy.currentResource.iconType === 'Icon')
                  showField: (proxy) => {
                    // console.log(`proxy.currentResource`, proxy.currentResource)
                    // return true
                    return proxy.currentResource.vendor != "SKUX"
                  },
                  props: {
                    labelKey: 'Button URL'
                  }
                },

                {
                  type: 'contenteditable',
                  name: 'approvedEmailFooter',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.approved_email_data.footer'
                  }
                },


                {
                  type: 'hardcodedText',
                  showField: (proxy) => (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    heading: 'Rejected Email',
                    text: "Sent to a consumer when their submission is rejected in the admin tool."
                  }
                },
                {
                  type: 'text',
                  name: 'rejectedEmailSubject',
                  required: true,
                  props: {
                    labelKey: 'Subject'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'rejectedEmailTitle',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.title'
                  }
                },
                {
                  type: 'contenteditable',
                  name: 'rejectedEmailBody',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.body'
                  }
                },
                {
                  type: 'text',
                  name: 'rejectedEmailButtonCopy',
                  required: false,
                  props: {
                    labelKey: 'Button Copy'
                  }
                },
                {
                  type: 'text',
                  name: 'rejectedEmailButtonUrl',
                  required: false,
                  props: {
                    labelKey: 'Button URL'
                  }
                }, {
                  type: 'contenteditable',
                  name: 'rejectedEmailFooter',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.footer'
                  }
                },

              ]
            },

            {
              subSection: true,
              key: "rewardSms",
              sectionWrapper: IndexedSubSectionWrapper,
              showSection: (proxy) => ((proxy.parentCurrentResource.communicationChannelAvailable === 'sms') || (proxy.parentCurrentResource.communicationChannelAvailable === 'either')),
              props: {
                innerHeader: true,
                getInnerHeader: () => <Fragment>Reward-Specific SMS</Fragment>
              },
              fields: [
                // {
                //     type: 'hardcodedText',
                //     showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                //     props: {
                //       heading: 'Submission Received Email',
                //       text: "Sent immediately to a consumer when they submit a receipt. Will include a link to check the status of their submission."
                //     }
                //   },                    
                {
                  type: 'textarea',
                  name: 'submittedSms',
                  required: true,
                  props: {
                    labelKey: 'Submission Received by Breaktime',
                    maxLengthHint: 140
                  }
                },
                {
                  type: 'textarea',
                  name: 'approvedSms',
                  required: true,
                  props: {
                    labelKey: 'Submission Approved by Breaktime',
                    helperText: "For SKUx rewards include ${link} where the link to the reward should go in the message",
                    maxLengthHint: 140
                  }
                },
                {
                  type: 'textarea',
                  name: 'rejectedSms',
                  required: true,
                  props: {
                    labelKey: 'Submission Rejected by Breaktime',
                    maxLengthHint: 140
                  }
                },

              ]
            }


          ]
        },

        {
          type: 'number',
          name: 'breaktimeCodesRedemptionLimit',
          required: false,
          props: {
            min: 0,
            labelKey: 'Breaktime Codes Redemption Limit'
          }
        }

      ]
    },
    {
      subSection: true,
      key: "uploadScreen",
      index: 10,
      sectionWrapper: IndexedSubSectionWrapper,

      props: {
        innerHeader: true,
        getInnerHeader: () => 'Upload Screen'
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'uploadHeadline',
          required: false,
          props: {
            labelKey: 'Headline'
          }
        },
        {
          type: 'contenteditable',
          name: 'uploadIntroCopy',
          required: false,
          props: {
            labelKey: 'Intro Copy'
          }
        },

      ]
    },
    // Review your Submissions
    {
      subSection: true,
      key: "receiptRequirements",
      sectionWrapper: IndexedSubSectionWrapper,

      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment>Review Submission Screen</Fragment>
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'detailedInstructionsHeader',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        {
          type: 'contenteditable',
          name: 'detailedInstructionsCopy',
          required: false,
          props: {
            labelKey: 'Body Copy'
          }
        },
        {
          type: 'contenteditable',
          name: 'detailedInstructionsRequiredItemListHeader',
          required: false,
          props: {
            labelKey: 'Required Item List Header'
          }
        },
        {
          name: 'detailedInstructions',
          resource: true,
          subSection: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          sortable: true,
          sortableName: "detailedInstructionsOrder",
          toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
          deletable: true,
          deleteAdditionalArgs: () => ({ instructionListName: "reminderInstructions" }),
          additionalData: { "foo": "foo1" },
          canDelete: (formProxy) => {
            var receiptCampaign = formProxy.parentCurrentResource;
            return receiptCampaign.detailedInstructions && receiptCampaign.detailedInstructions.length > 1;
          },
          resourceType: ResourceApi.Types.ReceiptCampaignDetailedInstruction,

          props: {
            headerKey: 'editbreak.steps.receipt.requirements.header',
            getCustomSectionHeader: (instruction, sectionIndex) => {
              return "Requirement Item " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
            },
            additionalData: { "bar": "bar1" },
          },

          footerContent: createButtonSectionFactoryWithAdditionalArgs({
            instructionListName: "detailedInstructions"
          }, ResourceApi.Types.ReceiptCampaignDetailedInstruction),

          fields: [
            {
              type: 'contenteditable',
              name: 'desc',
              additionalData: { "baz": "baz1" },
              args: { buz: "buz1" },
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.requirement.description',
                args: { qux: "qux1" },
              }
            }
          ]
        },
        {
          type: 'hardcodedText',
          props: {
            text: "Confirmation Checkboxes are under Rewards & Reward-Specific Copy"
          }
        },

      ]
    },  // end requirements accordion
    {
      subSection: true,
      key: "receiptReminder",
      sectionWrapper: IndexedSubSectionWrapper,

      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment>Set a Reminder Screen</Fragment>
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'reminderHeader',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderCopy',
          required: false,
          props: {
            labelKey: 'Body Copy'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderConfirmationCopy',
          required: false,
          showFiled: (proxy) => (showEmailFields(proxy.currentResource)),

          props: {
            labelKey: 'Confirmation checkbox copy (email)',
            helperText: "Here is some default copy. Switch over to html mode and paste this: *By clicking Submit, I acknowledge that I have read and agree to be bound by the Breaktime Media MWH, LLC <a href=\"https://www.dailybreak.com/terms\" target=\"_blank\">Terms &amp; Conditions</a> and <a href=\"https://www.dailybreak.com/privacy\" target=\"_blank\">Privacy Policy</a>."

          }
        },
        {
          type: 'contenteditable',
          name: 'reminderConfirmationCopySms',
          required: false,
          showField: (proxy) => ((proxy.currentResource.communicationChannelAvailable === 'sms') || (proxy.currentResource.communicationChannelAvailable === 'either')),
          props: {
            labelKey: 'Confirmation checkbox copy (SMS)',
            helperText: ""

          }
        },
      ]
    },
    {
      subSection: true,
      key: "receiptReminderThanks",
      sectionWrapper: IndexedSubSectionWrapper,

      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment>Reminder Thank You Screen</Fragment>
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'reminderThanksHeader',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderThanksCopy',
          required: false,
          props: {
            labelKey: 'Body Copy'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderThanksInstructionsHeader',
          required: false,
          props: {
            labelKey: 'Item List Header (e.g. How it works)'
          }
        },
        {
          name: 'reminderInstructions',
          resource: true,
          subSection: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          sortable: true,
          sortableName: "reminderInstructionsOrder",
          toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
          deletable: true,
          deleteAdditionalArgs: () => ({ instructionListName: "reminderInstructions" }),
          additionalData: { "foo": "foo1" },
          canDelete: (formProxy) => {
            var receiptCampaign = formProxy.parentCurrentResource;
            return receiptCampaign.reminderInstructions && receiptCampaign.reminderInstructions.length > 1;
          },
          resourceType: ResourceApi.Types.ReceiptCampaignReminderInstruction,

          props: {
            headerKey: 'editbreak.steps.receipt.requirements.header',
            getCustomSectionHeader: (instruction, sectionIndex) => {
              return "Instruction " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
            },
            additionalData: { "bar": "bar1" },
          },

          footerContent: createButtonSectionFactoryWithAdditionalArgs({
            instructionListName: "reminderInstructions"
          }, ResourceApi.Types.ReceiptCampaignReminderInstruction),

          fields: [
            {
              type: 'contenteditable',
              name: 'desc',
              required: true,
              props: {
                labelKey: 'Copy',
                additionalData: { "baz": "baz1" },
              }
            }
          ]
        }

      ]
    },
    {
      subSection: true,
      key: "receiptReminderEmails",
      sectionWrapper: IndexedSubSectionWrapper,
      showSection: (proxy) => (showEmailFields(proxy.currentResource)),

      //   showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment>Reminder Emails</Fragment>
      },
      fields: [
        {
          type: 'hardcodedText',
          props: {
            heading: 'Reminder Setup Email',
            text: "Reminder Setup is sent immediately when a consumer requests a reminder to confirm that they are all set."
          }
        },
        {
          type: 'text',
          name: 'reminderSetupEmailSubject',
          required: false,
          props: {
            labelKey: 'Subject'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderSetupEmailTitle',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        // {
        //   type: 'image',
        //   name: 'reminderSetupEmailImageId',
        //   idFor: 'reminderSetupEmailImage',
        //   required: false,
        //   props: {
        //     labelKey: 'Image',
        //     imageType: 'receiptHeader' 
        //   }
        // },
        {
          type: 'contenteditable',
          name: 'reminderSetupEmailBody',
          required: false,
          props: {
            labelKey: 'Body'
          }
        },
        {
          type: 'text',
          name: 'reminderSetupEmailButtonCopy',
          required: false,
          props: {
            labelKey: 'Button Copy'
          }
        },
        {
          type: 'text',
          name: 'reminderSetupEmailButtonUrl',
          required: false,

          props: {
            labelKey: 'Button URL'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderSetupEmailFooter',
          required: false,
          props: {
            labelKey: 'Footer'
          }
        },

        // 
        {
          type: 'hardcodedText',
          props: {
            heading: 'Reminder Email',
          }
        },
        {
          type: 'text',
          name: 'reminderEmailSubject',
          required: false,
          props: {
            labelKey: 'Subject'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderEmailTitle',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        // {
        //   type: 'image',
        //   name: 'reminderEmailImageId',
        //   idFor: 'reminderEmailImage',
        //   required: false,
        //   props: {
        //     labelKey: 'Image',
        //     imageType: 'receiptHeader' 
        //   }
        // },
        {
          type: 'contenteditable',
          name: 'reminderEmailBody',
          required: false,
          props: {
            labelKey: 'Body'
          }
        },
        {
          type: 'text',
          name: 'reminderEmailButtonCopy',
          required: false,
          props: {
            labelKey: 'Button Copy'
          }
        },
        {
          type: 'text',
          name: 'reminderEmailButtonUrl',
          required: false,
          props: {
            labelKey: 'Button URL'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminderEmailFooter',
          required: false,
          props: {
            labelKey: 'Footer'
          }
        },



        // 
        {
          type: 'hardcodedText',
          props: {
            heading: 'Second Reminder Email',
          }
        },
        {
          type: 'text',
          name: 'reminder2EmailSubject',
          required: false,
          props: {
            labelKey: 'Subject'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminder2EmailTitle',
          required: false,
          props: {
            labelKey: 'Header'
          }
        },
        // {
        //   type: 'image',
        //   name: 'reminder2EmailImageId',
        //   idFor: 'reminder2EmailImage',
        //   required: false,
        //   props: {
        //     labelKey: 'Image',
        //     imageType: 'receiptHeader' 
        //   }
        // },
        {
          type: 'contenteditable',
          name: 'reminder2EmailBody',
          required: false,
          props: {
            labelKey: 'Body'
          }
        },
        {
          type: 'text',
          name: 'reminder2EmailButtonCopy',
          required: false,
          props: {
            labelKey: 'Button Copy'
          }
        },
        {
          type: 'text',
          name: 'reminder2EmailButtonUrl',
          required: false,
          props: {
            labelKey: 'Button URL'
          }
        },
        {
          type: 'contenteditable',
          name: 'reminder2EmailFooter',
          required: false,
          props: {
            labelKey: 'Footer'
          }
        },



      ]
    },
    {
      subSection: true,
      key: "receiptReminderSms",
      sectionWrapper: IndexedSubSectionWrapper,
      // showSection: (proxy) => ( (proxy.currentResource.communicationChannelAvailable === 'sms') || (proxy.currentResource.communicationChannelAvailable === 'either') ),
      showSection: (proxy) => {
        console.log(`receiptReminderSms`, proxy.currentResource.communicationChannelAvailable)
        return ((proxy.currentResource.communicationChannelAvailable === 'sms') || (proxy.currentResource.communicationChannelAvailable === 'either'))
      },
      //   showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment>Reminder SMS</Fragment>
      },
      fields: [
        //   {
        //     type: 'hardcodedText',
        //     props: {
        //       heading: 'Reminder Setup Email',
        //       text: "Reminder Setup is sent immediately when a consumer requests a reminder to confirm that they are all set."
        //     }
        //   },
        {
          type: 'textarea',
          name: 'reminderSetupSms',
          required: false,
          props: {
            labelKey: 'Reminder Setup Message',
            helperText: "Sent to the consumer as soon as they ask for a reminder (confirms their request)",
            maxLengthHint: 140
          }
        },
      ]
    },
    {
      subSection: true,
      key: 'receiptEscrowSection',
      sectionWrapper: IndexedSubSectionWrapper,
      props: {
        innerHeader: true,
        getInnerHeader: () => (
          <Fragment>
            <FormattedMessage id={`editbreak.steps.receipt_verification.innerHeading`} />
            <FormattedMessage id={'editbreak.steps.receipt_verification.escrow_section'} />
          </Fragment>
        )
      },
      fields: [
        {
          type: 'campaignEscrowWidget'
        }
      ]
    },
    {
      subSection: true,
      key: 'receiptSubmissionSection',
      sectionWrapper: IndexedSubSectionWrapper,
      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment><FormattedMessage id={`editbreak.steps.receipt_verification.innerHeading`} /><FormattedMessage id={'editbreak.steps.receipt_verification.submission_section'} /></Fragment>
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'waitingDescription',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.submission.verification_pending_text'
          }
        },
        {
          type: 'number',
          name: 'legalSubmissionLimit',
          required: true,
          props: {
            min: 0,
            labelKey: 'editbreak.steps.receipt_verification.submission.submission_limit'
          }
        },
        {
          type: 'datetime',
          name: 'uploadByDate',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.submission.submission_cutoff'
          }
        },
        {
          type: 'number',
          name: 'approvedReceiptsPerUserLimit',
          required: false,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.submission.approvedReceiptsPerUserLimit'
          }
        },
        {
          name: 'approvedReceiptsPerUserLimitType',
          type: 'radio',
          showField: (proxy) => (proxy.currentResource.approvedReceiptsPerUserLimit && proxy.currentResource.approvedReceiptsPerUserLimit > 0),
          required: true,
          props: {
            labelKey: 'Approved Receipts Per User Limit Type (Duration)',
            options: [
              {
                value: 'campaign',
                textKey: 'By Campaign'
              },
              {
                value: 'daily',
                textKey: 'Daily'
              },

            ]
          }
        },




        {
          type: 'text',
          pathOverride: toParentField("nextBreakIds"),
          showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.steps.receipt_verification.nextBreakIds',
            asList: true
          }
        },
        {
          type: 'text',
          pathOverride: toParentField("excludeNextBreakIdList"),
          showField: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
          props: {
            labelKey: 'editbreak.steps.receipt_verification.excludeNextBreakIdList',
            asList: true
          }
        }
      ]
    },
    {
      subSection: true,
      key: "receiptOnSiteNotificationSection",
      sectionWrapper: IndexedSubSectionWrapper,
      showSection: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment><FormattedMessage id={`editbreak.steps.receipt_verification.innerHeading`} /><FormattedMessage id={'editbreak.steps.receipt_verification.on_site_result_section'} /></Fragment>
      },
      fields: [
        {
          type: 'contenteditable',
          name: 'rejectedText',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.on_site_result_section.rejected_text'
          }
        },
        {
          type: 'contenteditable',
          name: 'approvedText',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.on_site_result_section.approved_text'
          }
        },
        {
          type: 'text',
          name: 'supportEmail',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.on_site_result_section.support_email'
          }
        },
        {
          type: 'text',
          name: 'supportPhone',
          required: false,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.on_site_result_section.support_phone'
          }
        }
      ]
    },
    {
      subSection: true,
      name: 'approvedEmailData',
      hideIfResourceIsNoU: true,
      showSection: (proxy) => (!isNewLayout(proxy.currentBaseResource)),
      resource: true,
      sectionWrapper: IndexedSubSectionWrapper,
      props: {
        innerHeader: true,
        getInnerHeader: () => <Fragment><FormattedMessage id={`editbreak.steps.receipt_verification.innerHeading`} /><FormattedMessage id={'editbreak.steps.receipt_verification.approved_email_data'} /></Fragment>
      },
      fields: [
        {
          type: 'text',
          name: 'title',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.title'
          }
        },
        {
          type: 'textarea',
          name: 'body',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.body'
          }
        },
        /*{
          type: 'textarea',
          name: 'privacyPolicy',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.privacy_policy'
          }
        },
        {
          type: 'textarea',
          name: 'privacyPolicyLink',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.privacy_policy_link'
          }
        },*/
        {
          type: 'textarea',
          name: 'footerText',
          required: true,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.footer'
          }
        },
        {
          type: 'image',
          name: 'clientLogoId',
          idFor: 'clientLogo',
          required: false,
          props: {
            labelKey: 'editbreak.steps.receipt_verification.approved_email_data.client_logo',
            imageType: 'clientLogo'
          }
        }
      ]
    },  // end email approval section
    {
      type: 'hardcodedButton',
      props: {
        getUrl: (proxy) => `/receipt/${proxy.currentResource.id}?processingStatus=PENDING`,
        relativeUrl: true,
        textKey: 'buttons.view_pending_submissions'
      }
    },
    {
      type: 'currentId',
      label: 'Receipt Verification ID',
    },
    {
      type: "receiptCampaignDropdown",
      name: "receiptCampaignId",
      required: false,
      props: {
        labelKey: "Receipt Campaign",
        placeholderKey: "Select a receipt campaign"
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/receipt-verification.js